export default __webpack_public_path__ + "static/tbd-09d5d932e5a51a4c3097bc6b7f8fe5d4.png";